/* Centre the resting nav using its real loaded letter widths; preserve scroll animation. */
(function () {
  function init() {
    var nav = document.querySelector('.nav-split');
    if (!nav || nav.dataset.typographyMeasured) return;
    nav.dataset.typographyMeasured = 'true';
    var left = nav.querySelector('.g1'), right = nav.querySelector('.g2');
    var logo = document.querySelector('.logo-img');
    if (!left || !right || !logo) return;
    function measure() {
      if (innerWidth <= 1024) return;
      var delta = -(right.getBoundingClientRect().width - left.getBoundingClientRect().width) / 2;
      document.documentElement.style.setProperty('--shift0', delta + 'px');
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (scrollY !== 0 && innerWidth >= 1328) return;
        var centre = (left.getBoundingClientRect().left + right.getBoundingClientRect().right) / 2;
        var current = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--shift0')) || 0;
        var logoBox = logo.getBoundingClientRect();
        var target = logoBox.left + logoBox.width / 2;
        document.documentElement.style.setProperty('--shift0', (current + target - centre) + 'px');
      }); });
    }
    document.fonts.ready.then(measure);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(measure);
      observer.observe(left); observer.observe(right);
    }
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', function () { if (scrollY === 0) measure(); }, {passive:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
